import axios from 'axios';
import { API_URL } from '../config/env';
import { getUserToken } from './utils';

axios.defaults.validateStatus = false;
axios.defaults.baseURL = API_URL;

// const ROOT_URL = 'https://horsesfirst.qtipmeapi.com/api-v1';

export function getConfig(form = false, avatar = false, data) {
  if (getUserToken()) {
    const avatarType = avatar
      ? 'multipart/form-data'
      : 'application/x-www-form-urlencoded';
    const contentType = form ? avatarType : 'application/json';
    if (!getUserToken()) {
      return {
        headers: {
          'Content-Type': contentType,
        },
      };
    }
    if (data) {
      return {
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          'Content-Type': contentType,
        },
        data: data,
      };
    }
    return {
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
        'Content-Type': contentType,
      },
    };
  }
  return {};
}

export async function registerUser(payload) {
  return await axios.post(`/users`, payload, getConfig());
}
export async function getToken(payload) {
  return await axios.post(`/auth`, payload);
}
export async function getProfile(token) {
  return await axios.get(`/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function requestForgotPassword(payload) {
  return await axios.post(`/forgot-password`, payload);
}
export async function postResetPassword(payload) {
  return await axios.post(`/reset-password`, payload);
}

export async function registerCompany(payload) {
  // const data = new FormData();
  // data.append('username', payload.username);
  // data.append('email', payload.email);
  // if (payload.phone !== '') {
  // 	data.append('phone', payload.phone);
  // }
  // if (payload.companyId !== '') {
  // 	data.append('company_id', payload.companyId);
  // }
  // if (payload.companyName !== '') {
  // 	data.append('company_name', payload.companyName);
  // }
  // if (payload.address !== '') {
  // 	data.append('address', payload.address);
  // }
  // if (payload.logoUrl !== '') {
  // 	data.append('logo_url', payload.logoUrl);
  // }
  // if (payload.bannerUrl !== '') {
  // 	data.append('banner_url', payload.bannerUrl);
  // }
  // if (payload.homepageUrl !== '') {
  // 	const formatUrl = payload.homepageUrl.indexOf('https://') !== -1 ? payload.homepageUrl : `https://${payload.homepageUrl}`;
  // 	data.append('homepage_url', formatUrl);
  // }
  // if (payload.description !== '') {
  // 	data.append('description', payload.description);
  // }
  // if (payload.city !== '') {
  // 	data.append('city', payload.city);
  // }
  // if (payload.lat !== '') {
  // 	data.append('lat', payload.lat.toFixed(12));
  // }
  // if (payload.lng !== '') {
  // 	data.append('lng', payload.lng.toFixed(12));
  // }
  // if (payload.areaCode !== '') {
  // 	data.append('area_code', payload.areaCode);
  // }
  // data.append('token', WRITE_KEY);
  // data.append('token_id', TOKEN_ID)
  // const requestOptions = {
  // 	url: `${ROOT_URL}/portal/register-company.php`,
  // 	method: 'POST',
  // 	headers: {
  // 		'X-CORS-Access-Key': 'herp-derp',
  // 	},
  // 	data,
  // };
  // return await axios(requestOptions);
}
export async function changePassword(payload) {
  return await axios.patch(`/me/password`, payload, getConfig());
}
export async function updateProfile(payload) {
  return await axios.patch(`/me`, payload, getConfig());
}

export async function getCategories(type = 0) {
  return await axios.get(`/categories?type=${type}`, getConfig());
}
export async function getNotifications(payload) {
  const page = payload && payload.page ? payload.page : '';
  return await axios.get(`/notifications?page=${page}`, getConfig());
}
export async function checkNotification() {
  return await axios.get(`/notifications/check`, getConfig());
}

export async function readNotification(payload) {
  return await axios.patch(
    `/notifications/${payload.id}`,
    payload,
    getConfig(),
  );
}

export async function getProducts(payload) {
  let params = '';
  if (payload && payload.category && payload.category !== 0) {
    params = `&category=${payload.category}`;
  }
  const page = payload && payload.page ? payload.page : '';
  const all = payload && payload.all ? payload.all : false;
  return await axios.get(`/products?page=${page}${params}&all=${all}`);
}
export async function getCompanySellers(payload) {
  return await axios.get(`/company/${payload.id}/sellers`, getConfig());
}
export async function getSellerUsers(payload) {
  let params = '';
  if (payload.subscription) {
    params += `&subscription=${payload.subscription}`;
  }
  return await axios.get(`/sellers?${params}`, getConfig());
}
export async function subscribeSeller(payload) {
  return await axios.post(`/subscriptions`, payload, getConfig());
}
export async function unsubscribeSeller(payload) {
  return await axios.patch(`/subscriptions`, payload, getConfig());
}
export async function addCompanySeller(payload) {
  return await axios.post(
    `/company/${payload.id}/invite`,
    payload,
    getConfig(),
  );
}
export async function acceptCompanyInvitation(payload) {
  return await axios.post(
    `/company/${payload.id}/accept`,
    payload,
    getConfig(),
  );
}

export async function getCompanyDetail(payload) {
  return await axios.get(`/company/${payload.id}`, getConfig());
}
export async function updateCompanyDetail(payload) {
  return await axios.patch(`/company/${payload.id}`, payload, getConfig());
}

export async function getCompanyMembers(payload) {
  return await axios.get(`/company/${payload.id}/members`, getConfig());
}

export async function deactivateCompanyMember(payload) {
  return await axios.post(
    `/company/${payload.id}/deactivate`,
    payload,
    getConfig(),
  );
}

export async function getProductDetail(payload) {
  return await axios.get(`/products/${payload.id}`, getConfig());
}
export async function getInventoryDetail(payload) {
  return await axios.get(`/additional-items/${payload.id}`, getConfig());
}
export async function getItems(payload) {
  let params = '?';
  if (payload && payload.stableId) {
    params = `stable_id=${payload.stableId}`;
  }
  let all = false;
  if (payload && payload.all) {
    all = payload.all;
  }
  return await axios.get(
    `/items${params}&page=${payload.page}&all=${all}`,
    getConfig(),
  );
}
export async function getStables() {
  return await axios.get(`/stables`, getConfig());
}
export async function getItemDetail(payload) {
  return await axios.get(`/items/${payload.id}`, getConfig());
}
export async function getStableDetail(payload) {
  return await axios.get(`/stables/${payload.id}`, getConfig());
}

export async function addProduct(payload) {
  return await axios.post(`/products`, payload, getConfig());
}
export async function addInventory(payload) {
  return await axios.post(`/additional-items`, payload, getConfig());
}
export async function addItem(payload) {
  return await axios.post('/items', payload, getConfig());
}
export async function addStable(payload) {
  return await axios.post('/stables', payload, getConfig());
}
export async function updateItem(payload) {
  return await axios.patch(`/items/${payload.id}`, payload, getConfig());
}
export async function updateStable(payload) {
  return await axios.patch(`/stables/${payload.id}`, payload, getConfig());
}
export async function deleteItem(payload) {
  return await axios.delete(`/items/${payload.id}`, getConfig());
}

export async function getCustomers() {
  return await axios.get(`/customers`, getConfig());
}
export async function getCustomerDetail(payload) {
  return await axios.get(`/customers/${payload.id}`, getConfig());
}
export async function addCustomer(payload) {
  return await axios.post('/customers', payload, getConfig());
}
export async function updateCustomer(payload) {
  return await axios.patch(`/customers/${payload.id}`, payload, getConfig());
}
export async function deleteCustomer(payload) {
  return await axios.delete(`/customers/${payload.id}`, getConfig());
}

export async function getSellerProducts(payload) {
  let params = '';
  if (payload && payload.category && payload.category !== 0) {
    params = `&category=${payload.category}`;
  }
  const page = payload && payload.page ? payload.page : '';
  const all = payload && payload.all ? payload.all : false;
  return await axios.get(
    `/products?page=${page}${params}&all=${all}`,
    getConfig(),
  );
}
export async function getSellerInventory(payload) {
  const page = payload && payload.page ? payload.page : '';
  const type = payload && payload.type ? payload.type : 0;
  const company_id =
    payload && payload.company_id ? `&company_id=${payload.company_id}` : '';
  return await axios.get(
    `/additional-items?page=${page}&type=${type}${company_id}`,
    getConfig(),
  );
}

export async function syncProducts(payload) {
  return await axios.get(`/company/${payload.id}/sync`, getConfig());
}

export async function sellerAddProduct(payload) {
  return await axios.post(`/products`, payload, getConfig());
}
export async function getCompanyProductDetail(payload) {
  // const data = new FormData();
  // data.append('token', payload.token);
  // data.append('token_id', payload.tokenId)
  // data.append('product_id', payload.product_id)
  // const requestOptions = {
  // 	url: `${ROOT_URL}/portal/company/get-product-details.php`,
  // 	method: 'POST',
  // 	headers: {
  // 		'X-CORS-Access-Key': 'herp-derp',
  // 	},
  // 	data,
  // };
  // try {
  // 	const response = await axios(requestOptions)
  // 	const newData = response.data || null;
  // 	return newData;
  // } catch (error) {
  // 	console.log(error);
  // }
}

export async function updateProduct(payload) {
  return await axios.patch(`/products/${payload.id}`, payload, getConfig());
}
export async function deleteProduct(payload) {
  return await axios.delete(`/products/${payload.id}`, getConfig());
}
export async function updateInventory(payload) {
  return await axios.patch(
    `/additional-items/${payload.id}`,
    payload,
    getConfig(),
  );
}
export async function deleteInventory(payload) {
  return await axios.delete(`/additional-items/${payload.id}`, getConfig());
}

export async function getTransaction(payload = null) {
  const page = payload && payload.page ? payload.page : '';
  const item = payload && payload.itemId ? payload.itemId : '';
  const startDate = payload && payload.startDate ? payload.startDate : '';
  const endDate = payload && payload.endDate ? payload.endDate : '';
  const type = payload && payload.type ? payload.type : '';
  const status = payload && payload.status ? payload.status : '';
  const statusFrom = payload && payload.statusFrom ? payload.statusFrom : '';
  const show = payload && payload.show >= 0 ? payload.show : '';
  const all = payload && payload.all ? payload.all : '';
  const sort = payload && payload.sort ? payload.sort : '';
  const isCompany =
    payload && payload.isCompany ? `&is_company=${payload.isCompany}` : '';
  return await axios.get(
    `/transactions?page=${page}&item=${item}&start=${startDate}&end=${endDate}&type=${type}&status=${status}&statusFrom=${statusFrom}&all=${all}${isCompany}&show=${show}&sort=${sort}`,
    getConfig(),
  );
}
export async function searchTransaction(payload = null) {
  const page = payload && payload.page ? payload.page : '';
  const item = payload && payload.itemId ? payload.itemId : '';
  const startDate = payload && payload.startDate ? payload.startDate : '';
  const endDate = payload && payload.endDate ? payload.endDate : '';
  const type = payload && payload.type ? payload.type : '';
  const status = payload && payload.status ? [payload.status] : [];
  const statusFrom = payload && payload.statusFrom ? payload.statusFrom : '';
  const show = payload && payload.show >= 0 ? payload.show : '';
  const all = payload && payload.all ? payload.all : '';
  const sort = payload && payload.sort ? payload.sort : '';
  const isCompany =
    payload && payload.isCompany ? `&is_company=${payload.isCompany}` : '';
  return await axios.get(
    `/transactions/search?page=${page}&item=${item}&start=${startDate}&end=${endDate}&type=${type}&status=${status}&statusFrom=${statusFrom}&all=${all}${isCompany}&show=${show}&sort=${sort}`,
    getConfig(),
  );
}

export async function getCalendars(payload = null) {
  const page = payload && payload.page ? payload.page : '';
  const item = payload && payload.itemId ? payload.itemId : '';
  const startDate = payload && payload.startDate ? payload.startDate : '';
  const endDate = payload && payload.endDate ? payload.endDate : '';
  const type = payload && payload.type ? payload.type : '';
  const status = payload && payload.status ? payload.status : '';
  const statusFrom = payload && payload.statusFrom ? payload.statusFrom : '';
  const all = payload && payload.all ? payload.all : '';
  const isCompany =
    payload && payload.isCompany ? `&is_company=${payload.isCompany}` : '';
  const company =
    payload.company_id && payload.company_id !== '0'
      ? `&company=${payload.company_id}`
      : '';
  return await axios.get(
    `/calendars?page=${page}&item=${item}&start_date=${startDate}&end_date=${endDate}&type=${type}&status=${status}&statusFrom=${statusFrom}&all=${all}${isCompany}${company}`,
    getConfig(),
  );
}
export async function getTransactionCalendar(payload) {
  return await axios.get(
    `/calendars/transaction/${payload.transaction_id}`,
    getConfig(),
  );
}
export async function getTransactionExport(payload = null) {
  const page = payload && payload.page ? payload.page : '';
  const item = payload && payload.itemId ? payload.itemId : '';
  const startDate = payload && payload.startDate ? payload.startDate : '';
  const endDate = payload && payload.endDate ? payload.endDate : '';
  const type = payload && payload.type ? payload.type : '';
  const status = payload && payload.status ? payload.status : '';
  const statusFrom = payload && payload.statusFrom ? payload.statusFrom : '';
  const all = payload && payload.all ? payload.all : '';
  return await axios.get(
    `/transactions/export?page=${page}&item=${item}&start=${startDate}&end=${endDate}&type=${type}&status=${status}&statusFrom=${statusFrom}&all=${all}`,
    getConfig(),
  );
}

export async function getTransactionDetail(payload) {
  return await axios.get(`/transactions/${payload.id}`, getConfig());
}
export async function getTransactionAdditionalItems(payload) {
  return await axios.get(
    `/transactions/${payload.id}/additional-items`,
    getConfig(),
  );
}

export async function createTransaction(payload) {
  return await axios.post(`/transactions`, payload, getConfig());
}
export async function createCalendar(payload) {
  return await axios.post(`/calendars`, payload, getConfig());
}
export async function updateCalendar(payload) {
  return await axios.patch(
    `/calendars/${payload.calendar_id}`,
    payload,
    getConfig(),
  );
}
export async function createInvoice(payload) {
  return await axios.post(
    `/transactions/${payload.id}/pdf`,
    payload,
    getConfig(),
  );
}
export async function createCompany(payload) {
  return await axios.post(`/company`, payload, getConfig());
}
export async function sendInvoiceEmail(payload) {
  return await axios.post(
    `/transactions/${payload.id}/email`,
    payload,
    getConfig(),
  );
}

export async function addTransactionBid(payload) {
  return await axios.post(
    `/transactions/${payload.id}/bid`,
    payload,
    getConfig(),
  );
}
export async function updateTransactionStatus(payload) {
  return await axios.patch(`/transactions/${payload.id}`, payload, getConfig());
}
export async function addTransactionItemDetail(payload) {
  return await axios.patch(
    `/transactions/${payload.id}/items/${payload.itemId}`,
    payload,
    getConfig(),
  );
}
export async function getTransactionItemList(payload) {
  let params = '';
  if (payload.type) {
    params = params + `&type=${payload.type}`;
  }
  if (payload.companyId) {
    params = params + `&company_id=${payload.companyId}`;
  }
  if (payload.isCompanyOwner) {
    params = params + `&is_company_owner=true`;
  }
  return await axios.get(
    `/transactions/horses?product_id=${parseInt(payload.productId)}${params}`,
    getConfig(),
  );
}

export async function addTransactionAdditionalItems(payload) {
  return await axios.post(
    `/transactions/${payload.id}/additional-items`,
    payload,
    getConfig(),
  );
}
export async function addTransactionAdditionalItemsBatch(payload) {
  return await axios.post(
    `/transactions/${payload.id}/additional-items/batch`,
    payload,
    getConfig(),
  );
}

export async function addTransactionIndividualInvoice(payload) {
  return await axios.post(
    `/transactions/${payload.id}/invoices`,
    payload,
    getConfig(),
  );
}

export async function createIndividualInvoice(payload) {
  return await axios.post(
    `/transactions/${payload.id}/invoices/${payload.invoice_id}/pdf`,
    payload,
    getConfig(),
  );
}
export async function sendIndividualInvoiceEmail(payload) {
  return await axios.post(
    `/transactions/${payload.id}/invoices/${payload.invoice_id}/email`,
    payload,
    getConfig(),
  );
}

export async function uploadImage(payload) {
  const data = new FormData();
  data.append('file', payload.file);
  data.append('upload_preset', 'luokki');
  const apiUrl = `https://api.cloudinary.com/v1_1/luokki/upload`;
  return await axios.post(apiUrl, data);
}

export async function getGeoLocation(payload) {
  return await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?&latlng=${payload.lat},${payload.lng}&key=AIzaSyCuaV7aVdh3G0VmDW4wn3C9JJUGZXqGWaY`,
  );
}

export async function getComSeller(payload) {
  // const data = new FormData();
  // data.append('token', payload.token);
  // data.append('token_id', payload.tokenId)
  // const requestOptions = {
  // 	url: `${ROOT_URL}/portal/company/get-sellers.php`,
  // 	method: 'POST',
  // 	headers: {
  // 		'X-CORS-Access-Key': 'herp-derp',
  // 	},
  // 	data,
  // };
  // return await axios(requestOptions);
}
export async function getComSellerProduct(payload) {
  // const data = new FormData();
  // data.append('token', payload.token);
  // data.append('token_id', payload.tokenId)
  // data.append('seller_id', payload.sellerId)
  // if (payload.productId !== '') {
  // 	data.append('product_id', payload.productId)
  // }
  // if (payload.getImage) {
  // 	data.append('get_images', payload.getImage)
  // }
  // if (payload.getProperties) {
  // 	data.append('get_properties', payload.getProperties)
  // }
  // const requestOptions = {
  // 	url: `${ROOT_URL}/portal/company/get-seller-product-list.php`,
  // 	method: 'POST',
  // 	headers: {
  // 		'X-CORS-Access-Key': 'herp-derp',
  // 	},
  // 	data,
  // };
  // return await axios(requestOptions);
}
export async function getComSellerProductDetail(payload) {
  // const data = new FormData();
  // data.append('token', payload.token);
  // data.append('token_id', payload.tokenId)
  // data.append('seller_id', payload.sellerId)
  // data.append('product_id', payload.productId)
  // if (payload.getImage) {
  // 	data.append('get_images', payload.getImage)
  // }
  // if (payload.getProperties) {
  // 	data.append('get_properties', payload.getProperties)
  // }
  // const requestOptions = {
  // 	url: `${ROOT_URL}/portal/company/get-seller-product-details.php`,
  // 	method: 'POST',
  // 	headers: {
  // 		'X-CORS-Access-Key': 'herp-derp',
  // 	},
  // 	data,
  // };
  // return await axios(requestOptions);
}
export async function addProductToComCatalog(payload) {
  // const data = new FormData();
  // data.append('token', payload.token);
  // data.append('token_id', payload.tokenId)
  // data.append('product_owner_id', payload.sellerId)
  // data.append('product_id', payload.productId)
  // if (payload.priceMin) {
  // 	data.append('price_min', payload.priceMin)
  // }
  // if (payload.priceMax) {
  // 	data.append('price_max', payload.priceMax)
  // }
  // if (payload.status) {
  // 	data.append('status', payload.status)
  // }
  // const requestOptions = {
  // 	url: `${ROOT_URL}/portal/company/add-product-to-catalog.php`,
  // 	method: 'POST',
  // 	headers: {
  // 		'X-CORS-Access-Key': 'herp-derp',
  // 	},
  // 	data,
  // };
  // return await axios(requestOptions);
}
export async function getComCatalog(payload) {
  // const data = new FormData();
  // data.append('token', payload.token);
  // data.append('token_id', payload.tokenId)
  // if (payload.productId) {
  // 	data.append('product_id', payload.productId)
  // }
  // if (payload.getImage) {
  // 	data.append('get_images', payload.getImage)
  // }
  // if (payload.getProperties) {
  // 	data.append('product_id', payload.productId)
  // }
  // const requestOptions = {
  // 	url: `${ROOT_URL}/portal/company/get-catalog.php`,
  // 	method: 'POST',
  // 	headers: {
  // 		'X-CORS-Access-Key': 'herp-derp',
  // 	},
  // 	data,
  // };
  // return await axios(requestOptions);
}
